import styled from "styled-components";

export const Container = styled.div`
  margin-top: 25px;
`;

export const Title = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: row;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
`;

export const Division = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Item = styled.p`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  font-size: 18px;
`;

export const T = styled.b``;
